import { useState } from 'react';
import { useSwipeable } from 'react-swipeable';

import { Ticket } from '@/components/Ticket';
import { useMediaEffect } from '@/hooks/useMediaEffect';
import { ITicket } from '@/types';

interface ITicketSlider {
  tickets: ITicket[];
}

export function TicketsSlider({ tickets }: ITicketSlider) {
  const [currentSliderIndex, setCurrentSliderIndex] = useState(0);
  const viewPort = useMediaEffect();

  const ticketsLimitForSlider = {
    lg: 5,
    md: 4,
    sm: 2,
  }?.[viewPort];

  const amountOfSlides = Math.ceil(tickets.length / ticketsLimitForSlider);

  const startIndex = currentSliderIndex * ticketsLimitForSlider;
  const endIndex = startIndex + ticketsLimitForSlider;

  const isMoreTicketsThanLimit = amountOfSlides > 1;

  const slicedTickets = isMoreTicketsThanLimit ? tickets.slice(startIndex, endIndex) : tickets;

  const handleUpdateIndex = (newIndex: number) => {
    if (newIndex < 0) {
      setCurrentSliderIndex(amountOfSlides - 1);
      return;
    } else if (newIndex >= amountOfSlides) {
      setCurrentSliderIndex(0);
      return;
    }

    setCurrentSliderIndex(newIndex);
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleUpdateIndex(currentSliderIndex + 1),
    onSwipedRight: () => handleUpdateIndex(currentSliderIndex - 1),
  });

  return (
    <>
      <div {...swipeHandlers} className="mb-9 flex items-stretch justify-center h-full gap-[15px]">
        {slicedTickets.map((ticket) => (
          <Ticket key={ticket.description} ticket={ticket} />
        ))}
      </div>

      {isMoreTicketsThanLimit && (
        <div className="mb-10 flex justify-center">
          {[...new Array(amountOfSlides)].map((_, i) => (
            <div
              onClick={() => setCurrentSliderIndex(i)}
              key={i}
              className={`mr-2 h-2 w-2 cursor-pointer rounded-full ${
                currentSliderIndex === i ? 'bg-green' : ''
              } border-2 border-green`}
            />
          ))}
        </div>
      )}
    </>
  );
}
